module.exports = __webpack_public_path__ + "img/sm.381faefb.png";